export function getPaginationInfo(state) {
    return state.publications.pagination;
}

export function getTotalsInfo(state) {
    return state.publications.totals;
}

export function getPublications(state) {
    return state.publications.data;
}

export function getMetricsList(state) {
    return state.publications.metrics;
}

export function getAggregateMetricNames(state) {
    return state.publications.aggregateMetricNames;
}

export function getAggregateMetricValues(state) {
    return state.publications.aggregateMetricValues;
}

export function getPublicationAvailableFilters(state) {
    return state.publicationFilters.all;
}

export function getPublicationFiltersQueryString(state) {
    return state.publicationFilters.filterQueryString;
}

export function getPublicationSearchText(state) {
    return state.publicationFilters.searchText;
}

export function getPublicationListSortConfig(state) {
    return {
        sortField: state.publicationFilters.sortField,
        sortDirection: state.publicationFilters.sortDirection
    };
}

export function isPublicationDataLoading(state) {
    return state.publications.isFetching;
}

export function isExportingPublicationData(state) {
    return state.publications.isExporting;
}